import React from "react";
import Tooltip from "@mui/material/Tooltip";
import * as Styles from "../../styles";
import { Lead } from "../../../../../../interfaces";

interface Props {
  item: Lead;
}

export const UltimoResponsavelCell: React.FC<Props> = ({ item }) => (
  <Tooltip
    followCursor
    title={item?.nomeUltimoCorretorLead || "Sem informação"}
    placement="top-start"
    arrow
  >
    <Styles.Td>
      <div
        style={{
          display: "flex",
          justifyContent: "left",
          alignContent: "center",
          width: "100%",
          alignItems: "center",
        }}
      >
        {item?.nomeUltimoCorretorLead || "--"}
      </div>
    </Styles.Td>
  </Tooltip>
);
